// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","bottom":"bottom-3iOMm","promoCode__wrp":"promoCode__wrp-1U1PG","controls":"controls-7sh7n"};